import { gsap } from 'gsap'
gsap.registerPlugin()
const tl = gsap.timeline();

const headline = document.getElementById('top_headline')
const bottomHeadline = document.getElementById('bottom_headline')
let letterArr = headline.innerHTML.split('')
let bottomLetterArr = bottomHeadline.innerHTML.split('')
const textSizeDesktop = [140, 160, 180, 200, 220]
const textSizeMobile = [12, 14, 18]

const randomSize = (textSizeArr) => {
    let random = Math.floor(Math.random() * textSizeArr.length);
    let randomValue = textSizeArr[random];

    return randomValue
}


headline.innerHTML = ''
bottomHeadline.innerHTML = ''

const randomSizeHeadline = (arr, headline) => {
    for (let i = 0; i < arr.length; i++) {
        let newHeadline

        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) == true) {
            newHeadline = `<span class="letters" style="font-size: ${randomSize(textSizeMobile)}vw">${arr[i]}</span>`
            headline.innerHTML += newHeadline
        } else {
            newHeadline = `<span class="letters" style="font-size: ${randomSize(textSizeDesktop)}px">${arr[i]}</span>`
            headline.innerHTML += newHeadline
        }
    }
}
randomSizeHeadline(letterArr, headline)
randomSizeHeadline(bottomLetterArr, bottomHeadline)


const letters = document.querySelectorAll(".letters")
const loadingBG = document.getElementById('loading_bg')
const line = document.getElementById('loading_line')
const introText = document.querySelector('.intro')
const artists = document.querySelector('.artists')
const address = document.querySelector('.address')
const circle = document.querySelector('.circle')

gsap.set(line, { width: 0, background: 'white' });
gsap.set(loadingBG, { y: 0 });
gsap.set([letters, introText, artists, address, circle], { opacity: 0, y: 30 });

tl.to(line, {
    width: '100%',
    background: 'black',
    duration: 2,
    ease: "power2.inOut",
})
    .to(loadingBG, {
        y: "100vh",
        duration: 0.7,
        ease: "power4.inOut"
    }, "+=0.1")

    .to(letters, {
        y: 0,
        opacity: 1,
        stagger: {
            amount: 1.3,
            from: "start",
            ease: "sine.in"
        }
    }, "+=0.6")

    .to(introText, {
        y: 0,
        opacity: 1,
        stagger: {
            amount: 2,
            ease: "sine.in"
        }
    }, "+=0.5")
    .to(artists, {
        y: 0,
        opacity: 1,
        stagger: {
            amount: 2,
            ease: "sine.in"
        }
    }, "<")
    .to(address, {
        y: 0,
        opacity: 1,
        stagger: {
            amount: 2,
            ease: "sine.in"
        }
    }, "<")
    .to(circle, {
        y: 0,
        opacity: 1,
        stagger: {
            amount: 2,
            ease: "sine.in"
        }
    }, "<")


/** texts hover rotate 360 degree */
const menuItems = [...document.querySelectorAll('.menu_item')]
menuItems.forEach(item => {
    let word = item.children[0].children[0].innerText.split('')
    item.children[0].innerHTML = '' // div

    word.forEach((letter, index) => {
        if (letter === ' ') {
            letter = '&nbsp'
        }
        item.children[0].innerHTML += `<span style="--index: ${index};">${letter}</span>`
    })

    let cloneDiv = item.children[0].cloneNode(true)
    cloneDiv.style.position = 'absolute'
    cloneDiv.style.left = '0'
    cloneDiv.style.right = '0'
    cloneDiv.style.top = '0'
    item.appendChild(cloneDiv)
    // console.log(word); // 配列に１文字ずつ格納
})


/** contact rotation */
const text = document.querySelector('.rotate_txt')
const txtArr = text.innerText.split('')
text.innerHTML = ''
txtArr.forEach((char, index) => {
    let characters = `<span style="transform: rotate(${index * 15}deg)">${char}</span>`
    text.innerHTML += characters
})
